import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, description, children, className }: PageHeaderProps) {
  return (
    <div data-testid="page-header" className={cn("mb-5 flex flex-col gap-2 sm:mb-8 sm:flex-row sm:items-center sm:justify-between sm:gap-4", className)}>
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-[var(--color-foreground)] sm:text-3xl">{title}</h1>
        {description && (
          <div className="mt-1 text-sm text-[var(--color-muted-foreground)]">{description}</div>
        )}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
